import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {UserDetail} from '../../components/bulk-user-upload-module/models';

export interface BulkUploadInitialPage {
  users: UserDetail[];
  summary: {
    totalUsers?: number;
    totalErrorUsers?: number;
    totalExistingUser?: number;
    totalSuccessUsers?: number;
    totalErrors?: number;
  };
}

// Define the initial state for the slice
interface BulkUserFileNameState {
  fileName: string;
  file: File | undefined;
  fileUploadBatchId: string;
  fileProcessError: boolean;
  duplicateEmail: boolean;
  lookupClientList: any[];
  selectedClient: string;
  searchTerm?: string;
  initialUploadPage: BulkUploadInitialPage | null;
}

const initialState: BulkUserFileNameState = {
  fileName: '',
  file: undefined,
  fileUploadBatchId: '',
  fileProcessError: false,
  duplicateEmail: false,
  lookupClientList: [],
  selectedClient: '',
  searchTerm: '',
  initialUploadPage: null,
};

const BulkUserFileNameSlice = createSlice({
  name: 'bulkUserFileName',
  initialState,
  reducers: {
    setBulkUserFileName(state, action: PayloadAction<string>) {
      state.fileName = action.payload;
    },
    setBulkUserFile(state, action: PayloadAction<File>) {
      state.file = action.payload;
    },
    setFileUploadBatchId(state, action: PayloadAction<string>) {
      state.fileUploadBatchId = action.payload;
    },
    setFileProcessError(state, action: PayloadAction<boolean>) {
      state.fileProcessError = action.payload;
    },
    setDuplicateEmail(state, action: PayloadAction<boolean>) {
      state.duplicateEmail = action.payload;
    },
    setLookupClientList(state, action: PayloadAction<any>) {
      state.lookupClientList = action.payload;
    },
    setSelectedClient(state, action: PayloadAction<string>) {
      state.selectedClient = action.payload;
    },
    setSearchValues(state, action: PayloadAction<string>) {
      state.searchTerm = action.payload;
    },
    setInitialUploadPage(
      state,
      action: PayloadAction<BulkUploadInitialPage | null>
    ) {
      state.initialUploadPage = action.payload;
    },
    clearInitialUploadPage(state) {
      state.initialUploadPage = null;
    },
  },
});

export const {
  setBulkUserFileName,
  setBulkUserFile,
  setFileUploadBatchId,
  setFileProcessError,
  setDuplicateEmail,
  setSelectedClient,
  setSearchValues,
  setLookupClientList,
  setInitialUploadPage,
  clearInitialUploadPage,
} = BulkUserFileNameSlice.actions;

export default BulkUserFileNameSlice.reducer;
